import { render } from "./appdownload.vue?vue&type=template&id=1aeb7929&scoped=true"
import script from "./appdownload.vue?vue&type=script&lang=js"
export * from "./appdownload.vue?vue&type=script&lang=js"

import "./appdownload.vue?vue&type=style&index=0&id=1aeb7929&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/official-accounts/official-accounts/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeb7929"]])

export default __exports__